import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IUser, IWedding } from '../interface'
import { storeUserDataToStorage } from '../helpers/localStorageHelper.ts'

interface IUserState {
  userData: IUser | null;
  userWeddings: IWedding[]
  users: IUser[],
  selectedPartnerWeddings: IWedding[]
}

const initialState: IUserState = {
	userData: null,
	userWeddings: [],
	users: [],
	selectedPartnerWeddings: []
}

const userSlice = createSlice({
	name: 'userstore',
	initialState,
	reducers: {
		setUserData: (state: IUserState, action: PayloadAction<IUser>) => {
			state.userData = action.payload
			storeUserDataToStorage(action.payload)
		},
		setUserWeddings: (state: IUserState, action: PayloadAction<IWedding[]>) => {
			state.userWeddings = action.payload
		},
		setUsers: (state: IUserState, action: PayloadAction<IUser[]>) => {
			state.users = action.payload
		},
		setSelectedPartnerWeddings: (state: IUserState, action: PayloadAction<IWedding[]>) => {
			state.selectedPartnerWeddings = action.payload
		}
	}
})

export const {
	setUserData, setUserWeddings,
	setUsers,
	setSelectedPartnerWeddings
} = userSlice.actions
export default userSlice.reducer
